import * as React from 'react';

import styles from './styles.module.scss';

interface OwnProps {
	instructions: string;
}

type Props = OwnProps;

const FinalizeDescription: React.FC<Props> = (props) => {

	const { instructions } = props;

	return (
		<>
			<div className={styles.descriptionContainer}>
				<h2>Welcome to Acceligent!</h2>
				<h4><b>Powerful. Fast. Easy-to-use.</b></h4>
				<h4>
					Acceligent is a comprehensive solution that helps businesses bid smarter,
					utilize resources more efficiently and improve job performance.
				</h4>
			</div>
			<h4>{instructions}</h4>
		</>
	);
};

export default React.memo(FinalizeDescription);
